/** @jsx isolateComponent */
import { Fragment } from 'react';

import DocLinks from '@zapier/product-get-help/src/components/shared/DocLinks';
import { isolateComponent } from '@zapier/style-encapsulation';
import {
  Colors,
  Heading,
  HeadingLevel,
  Typography,
} from '@zapier/design-system';

type App = {
  id: string;
  name: string;
  slug: string;
};

type AppDocsProps = {
  /** Apps to link docs for */
  apps: App[];
};

const Styles = {
  title: {
    ...Typography.paragraph1ShortBold,
    color: Colors.gray,
  },
  rebrandTitle: {
    ...Typography.paragraph1ShortBold,
    color: Colors.neutral800,
  },
  list: {
    display: 'grid',
    rowGap: 15,
  },
  item: {
    display: 'grid',
    columnGap: 10,
    gridTemplateColumns: '30px 1fr',
    alignItems: 'center',
  },
  link: {
    ...Typography.smallPrint1,
    fontWeight: 700,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  rebrandLink: {
    ...Typography.smallPrint1,
    color: Colors.blueJeans,
    textDecoration: 'underline',
    '&:hover': {
      color: Colors.night,
    },
  },
};

/** Renders the list of general docs in `<DocsStep>`. */
const AppDocs = ({ apps }: AppDocsProps) => {
  /** Prevent duplicate app docs from being shown by checking
   *  that each app id only appears once. Maintains order of
   *  apps as used in the selected Zap.
   */
  const uniqueApps = apps.reduce<App[]>((acc, app) => {
    const uniqueAppIds = acc.map(accApp => accApp.id);
    if (!uniqueAppIds.includes(app.id)) acc.push(app);
    return acc;
  }, []);
  const DOC_LINKS = uniqueApps.map(app => ({
    title: `${app.name} help`,
    href: `/apps/${app.slug}/help`,
    appId: app.id,
  }));

  return (
    <Fragment>
      <Heading css={Styles.rebrandTitle}>Related</Heading>
      <HeadingLevel>
        <DocLinks links={DOC_LINKS} />
      </HeadingLevel>
    </Fragment>
  );
};

export default AppDocs;
